import { useCallback, useRef } from "react"

export function useCallOnce() {
  const calls = useRef<Record<string, boolean>>({})

  return useCallback((id: string, cb: () => any) => {
    if (calls.current[id]) {
      return
    }

    cb()
    calls.current[id] = true
  }, [])
}
